import Box from "@mui/material/Box";
import { Button, CircularProgress, TextField, Typography } from "@mui/material";
import AppButton from "../../common/AppButton";
import { useAppDispatch } from "../../../app/hooks";
import { useState } from "react";
import { addManufacturerValidationSchema } from "../../forms/validationSchemas";
import { addManufacturerInitialValues } from "../../forms/initialValues";
import { AddManufacturer } from "../../../features/manufacturer/manufacturerSlice";
import { Formik, Form, Field, ErrorMessage } from "formik";

interface IProps {
  handleClose: () => void;
  setOpenSnackbar: () => void;
  getManufacturer: () => void;
  filteredRowData?: any;
  setAddManufacturerId?: any;
}

const AddManufacturerModal = ({
  handleClose,
  setOpenSnackbar,
  getManufacturer,
  filteredRowData,
  setAddManufacturerId,
}: IProps) => {
  const dispatch = useAppDispatch();
  const [apiError, setApiError] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (values: any) => {
    setApiError(false);
    setLoading(true); // start the loader

    const newName = values?.manufacturer_name?.trim()?.toLowerCase();

    const isDuplicate = filteredRowData?.some(
      (manufacturer: any) =>
        manufacturer?.name?.trim()?.toLowerCase() === newName
    );
    if (isDuplicate) {
      setApiError(true);
      console.error("Manufacturer already exists.");
      setLoading(false); // Stop the loader
      return; // Stop execution if manufacturer already exists
    }
    try {
      const res = await dispatch(AddManufacturer(values));
      if (res?.payload?.success === true) {
        getManufacturer();
        setOpenSnackbar();
        handleClose();
        setAddManufacturerId(res?.payload?.data?.id);
      } else {
        setApiError(true);
      }
    } catch (error) {
      setApiError(true);
      console.error("Error adding manufacturer: ", error);
    } finally {
      setLoading(false); // Stop the loader
    }
  };

  return (
    <Formik
      initialValues={addManufacturerInitialValues}
      validationSchema={addManufacturerValidationSchema}
      onSubmit={handleSubmit}
    >
      <Form>
        <Box sx={{ mt: 1 }}>
          <Typography variant="h6" gutterBottom>
            Manufacturer Name
          </Typography>
          <Field
            as={TextField}
            fullWidth
            variant="outlined"
            name="manufacturer_name"
            inputProps={{ style: { padding: "10px 12px" } }}
          />
          <div
            style={{
              color: apiError ? "red" : "red",
              fontSize: "14px",
              marginTop: "5px",
            }}
          >
            {apiError && (
              <div> Manufacturer with this name already exists </div>
            )}
            <ErrorMessage name="manufacturer_name" component="div" />
          </div>
        </Box>

        <Box sx={{ mt: 2 }}>
          <AppButton
            variant="contained"
            color="primary"
            type="submit"
            title={
              loading ? <CircularProgress size={24} color="inherit" /> : "Add"
            }
            sx={{ float: "right" }}
            disabled={loading} // Disable button when loading
          />
        </Box>
      </Form>
    </Formik>
  );
};

export default AddManufacturerModal;
